"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchResultsTable = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Colors = __importStar(require("../colors"));
exports.ManagerSearchResultsTable = styled_components_1.default.table `
  width: 100%;

  th {
    font-weight: bold;
    text-align: left;
    padding: 5px 15px 15px 5px;
    vertical-align: middle;

    a {
      font-weight: bold;
      color: #000;
    }

    a:link {
      font-weight: bold;
      color: #000;
    }

    a:visited {
      font-weight: bold;
      color: #000;
    }

    a:hover {
      font-weight: bold;
      text-decoration: underline;
      color: #000;
    }

    a:active {
      font-weight: bold;
      color: #000;
    }
  }

  th:first-child {
  }

  tr {
    border-bottom: 1px solid ${Colors.searchFilterBorderColor};
  }
  td {
    padding: 5px;
    white-space: nowrap;
  }
  td:last-child {
    width: 100%;
  }
`;
//# sourceMappingURL=search-results-table.js.map